import Temp from "@/courier/Temp";
import courierRateScg from "@/plugins/courier_rate_scg.js";

export default class SCGExpress extends Temp {
  static CODE = "SCG";

  constructor() {
    super(SCGExpress.CODE);
  }

  async getZone(item) {
    let type, from, to;
    let cross_price = 0;
    let remote_area = 0;
    let fuel_surcharge = 0;
    let travel_surcharge = 0;

    remote_area = super.checkRemoteArea(Number(item.toPostcode));
    travel_surcharge = super.checkTravelSurcharge(Number(item.toPostcode))
    // console.log('SCG', remote_area);
    from = super.checkZone(item.fromPostcode);
    to = super.checkZone(item.toPostcode);
    const sameZone = to == from;

    if (from != to) {
      type = 2;
    } else {
      type = 1;
    }

    let fuel_prefix = sameZone ? "SAME_ZONE_" : "CROSS_ZONE_";
    fuel_surcharge = await super.scgFuelSurcharge( item.parcel.key_size, fuel_prefix )

    if (travel_surcharge && remote_area) {
      travel_surcharge = 0
    }

    return {
      rate_type: type,
      rate_remote_area: remote_area,
      travel_surcharge: travel_surcharge,
      cross_price: cross_price,
      fuel_surcharge: fuel_surcharge,
      fuel_prefix: fuel_prefix
    };
  }

  async checkWeight(courierRates, item) {
    let res = {
        index: item.index,
        findType: null,
        fuelSurcharge: 0
    };

    let SCGSize = item.sizeCheckPrice.SCGSize;
    let sizeFix = ['Envelop','PM','PL'];
    
    let indexSize = await super.checkSizeKey(item, SCGSize, sizeFix, {type: 'index' , weight: false}); 
    if( indexSize == -1 ) return res;

    let find_key = courierRateScg.findIndex((type) => {
      return type.key == item.keySize;
    });

    find_key = Math.max(indexSize , find_key);    

    if (find_key < 0) return res;
    res.findType = courierRateScg[find_key].weight.find((val) => {
      return item.weight <= val.max_weight;
    });

    if (res.findType == undefined) return res;
    res.index = courierRates.findIndex((rate) => {
      return rate.dimension == res.findType.size;
    });

    if(item.keySize != res.findType.size){
        res.fuelSurcharge = await super.scgFuelSurcharge( res.findType.size, item.fuelPrefix )
    }

    item.keySize = res.findType.size

    return res;
  }

  async checkRemoteAreaByCorrectorDest(addressRemote) {
    return new Promise((resolve) => {
      super.getArea([addressRemote], ["SCG"]).then((res) => {
        let returnRate = {
          isRemote: res.data.SCG?(res.data.SCG.is_remote?50:0):0,
          isTravelArea: 0,
          isIsland: 0
        };
        if (!returnRate.isRemote) {
          returnRate.isTravelArea = res.data.SCG?(res.data.SCG.is_tourist?50:0):0
        }
        resolve(returnRate);
      });
    });
  }
}
